module.exports = __webpack_public_path__ + "img/banner.a4ca2f7b.png";